import axios from 'axios';
import { ICrudPutAction } from 'react-jhipster';

import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';
import { SERVER_API_URL } from 'app/config/constants';

import { IPayment, defaultValue, IAsiaPayResult } from 'app/shared/model/payment.model';

export const ACTION_TYPES = {
  CREATE_PAYMENT: 'payment/CREATE_PAYMENT',
  PROCESS_DR: 'payment/PROCESS_DR',
  CASH_PAYMENT: 'payment/CASH_PAYMENT',
  ASIA_PAY_PAYMENT: 'payment/ASIA_PAY_PAYMENT',
  ASIA_PAY_RESULT: 'payment/ASIA_PAY_SUCCESS'
};

const initialState = {
  loading: false,
  errorMessage: null,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
  digitalOrder: '',
  digitalReceipt: null,
  invoiceNo: ''
};

export type PaymentState = Readonly<typeof initialState>;

// Reducer

export default (state: PaymentState = initialState, action): PaymentState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.CREATE_PAYMENT):
    case REQUEST(ACTION_TYPES.CASH_PAYMENT):
    case REQUEST(ACTION_TYPES.ASIA_PAY_PAYMENT):
      return {
        ...state,
        updating: true,
        errorMessage: null,
        updateSuccess: false
      };
    case FAILURE(ACTION_TYPES.CREATE_PAYMENT):
    case SUCCESS(ACTION_TYPES.CREATE_PAYMENT):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        digitalOrder: action.payload.data
      };
    case FAILURE(ACTION_TYPES.PROCESS_DR):
    case SUCCESS(ACTION_TYPES.PROCESS_DR):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        digitalReceipt: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.CASH_PAYMENT):
    case SUCCESS(ACTION_TYPES.ASIA_PAY_PAYMENT):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        invoiceNo: action.payload.data
      };
    case FAILURE(ACTION_TYPES.CASH_PAYMENT):
    case FAILURE(ACTION_TYPES.ASIA_PAY_PAYMENT):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload
      };
    default:
      return state;
  }
};

const jetcoApiUrl = SERVER_API_URL + '/api/payment/jetco';
const cashApiUrl = SERVER_API_URL + '/api/payment/cash';
const asiaPayApiUrl = SERVER_API_URL + '/api/payment/asiapay';

// Actions
export const createEntity: ICrudPutAction<IPayment> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_PAYMENT,
    payload: axios.post(jetcoApiUrl + '/pay', entity)
  });
  return result;
};

export const processDr = (dr, token) => async dispatch => {
  const body = new FormData();
  body.set('String1', dr);
  body.set('token', token);
  const result = await dispatch({
    type: ACTION_TYPES.PROCESS_DR,
    payload: axios.post(jetcoApiUrl + '/processDO', body)
  });
  return result;
};

export const payByCash: ICrudPutAction<IPayment> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CASH_PAYMENT,
    payload: axios.post(cashApiUrl + '/pay', entity)
  });
  return result;
};

export const payByAsiaPay: ICrudPutAction<IPayment> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.ASIA_PAY_PAYMENT,
    payload: axios.post(asiaPayApiUrl + '/pay', entity)
  });
  return result;
};

export const payByAsiaPaySuccess = (invoiceNo, token) => async dispatch => {
  const body = new FormData();
  body.set('invoiceNo', invoiceNo);
  body.set('token', token);
  const result = await dispatch({
    type: ACTION_TYPES.ASIA_PAY_RESULT,
    payload: axios.post(asiaPayApiUrl + '/success', body)
  });
  return result;
};

export const payByAsiaPayFailure = (invoiceNo, token) => async dispatch => {
  const body = new FormData();
  body.set('invoiceNo', invoiceNo);
  body.set('token', token);
  const result = await dispatch({
    type: ACTION_TYPES.ASIA_PAY_RESULT,
    payload: axios.post(asiaPayApiUrl + '/failure', body)
  });
  return result;
};
